.link {
  color: var(--ixf-text-tone-md);

  &:focus {
    outline: none;
  }
}
